import _ from 'lodash';
const application = [];

import accessControlRoutes from "@accessControlSrc/router/components"
import backendControlRoutes from "@backendControlSrc/router/components"

let components = _.merge(application, accessControlRoutes, backendControlRoutes);

export default components;
